/*
Adding this file here in FE repo to decouple the FE build process
later on we might need to fix this. But since this file is not 
generally changed we can keep it here for now.
*/

export class CapitalAllowanceChartService {

    static CHART_TYPE = "bar"
    static CHART_TITLE = "Capital Allowance"
  
    static checkLabels(chartLabels) {
      const errMsg =
        "The first column does not contain the required labels for creating this stacked bar chart (x-axis)";
      if (chartLabels) {
        const result = chartLabels.every(label => label && label.trim());
        if (!result) {
          return errMsg;
        } else return;
      }
      return errMsg;
    }

    static getTitle(chartType: string) {
      return chartType
        .toLowerCase()
        .split("_")
        .map((word) => word.replace(word[0], word[0].toLocaleUpperCase()))
        .join(" ");
    }
  
    static checkValue(dataset: any[]) {
      const result = dataset
        .flatMap(dataArr => dataArr)
        .every((value) => Number.isFinite(parseInt(value)) === true);
      if (!result) {
        return "Data in columns 2, column 3 (and column 4) must be numbers & the number of rows must be the same across all columns";
      } else {
        const difference = dataset
          .map(data => data.length)
          .every((v, i, arr) => v === arr[0]);
        return difference ? "" : "The number of rows are not the same across all columns";
      }
    }
  
    static checkChartRequirements(chartData, minColumnsRequired) {
      if (chartData && chartData.length < minColumnsRequired) {
        return "Not enough columns provided in table two for creating the chart";
      }
      return "";
    }
  
    static getData(columnLabels, chartData) {
      const data: any[] = [];
      if (chartData) {

        for (const i in chartData) {
          if (+i > 2) break;
          data.push({
            label: columnLabels[i],
            data: chartData[i],
          });
        }
      }
      data.map((set, i) => {
        switch (i) {
          case 0:
            set.backgroundColor = "#00C0AE";
            set.hoverBackgroundColor = "#00C0AE";
            set.stack = "Stack 0";
            break;
          case 1:
            set.backgroundColor = "#00338D";
            set.hoverBackgroundColor = "#00338D";
            set.stack = "Stack 0";
            break;
          case 2:
            set.backgroundColor = "#7213EA";
            set.hoverBackgroundColor = "#7213EA";
            set.stack = "Stack 1";
            break;
        }
      });
      if (data[2] !== undefined) {
        const [topStack0, bottomStack0, topStack1] = data;
        const bottomStack1 = { ...bottomStack0, stack: "Stack 1" }
        return [bottomStack0, topStack0, bottomStack1, topStack1];
      } else {
        const [topStack0, bottomStack0] = data;
        return [bottomStack0, topStack0];
      }
    }
  
    static getDefaultChartConfig() {
      return {
        type: CapitalAllowanceChartService.CHART_TYPE,
        minColumnsRequired: 3,
        options: {
          responsive: true,
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
          plugins: {
            legend: {
              labels: {
                filter: function(legendItem, chartData) {
                  const dupeIndex = chartData.datasets.findIndex(x => x.label === chartData.datasets[legendItem.datasetIndex].label);
                  if (legendItem.datasetIndex !== dupeIndex) {
                    return false
                  }
                  return true
                },
              },
            },
            title: {
              display: true,
              text: CapitalAllowanceChartService.CHART_TITLE,
            },
          },
        },
      }
    }
  }
  